import { render } from "./IconFooter.vue?vue&type=template&id=06652947"
import script from "./IconFooter.vue?vue&type=script&lang=js"
export * from "./IconFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__